import { render, staticRenderFns } from "./FormMaternity.vue?vue&type=template&id=47f7aab9&"
import script from "./FormMaternity.vue?vue&type=script&lang=js&"
export * from "./FormMaternity.vue?vue&type=script&lang=js&"
import style0 from "./FormMaternity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports